import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { Box, Divider, Flex, Icon, IconButton } from '@chakra-ui/react'

import {
  MessagesFilled,
  NotificationFilled,
  CalendarFilled,
} from '../icons/icons'
import { useUserWrapperContext } from '../wrappers/UserWrapper'
import { useNavigate } from 'react-router-dom'
import { SafeArea } from 'capacitor-plugin-safe-area'
import { useState, useEffect } from 'react'

const UserDefaultHeader = ({ newNotifications, newMessages }: { newNotifications: number; newMessages: number }) => {
  const { topCollapsed } = useUserWrapperContext()
  const navigate = useNavigate()
  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }
  const [statusBarHeight, setStatusBarHeight] = useState<number>(0)

  useEffect(() => {
    SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
      setStatusBarHeight(statusBarHeight)
    })
  }, [])

  return (
    <Box
      w="100%"
      h={topCollapsed ? '0' : 'auto'}
      overflow="hidden"
      bg={'white'}
      position="fixed"
      left="0"
      top="0"
      zIndex={9999}
      pt={`${statusBarHeight + 20}px`}
    >
      <Flex w="100%" justifyContent="space-between" alignItems="center" px="20px" pb="8px">
        <Flex alignItems="center" gap="6px" mb="-4px">
          <Box
            bgImage="/logo_black.svg"
            onClick={() => {
              navigate('/user')
            }}
            bgRepeat="no-repeat"
            w="62px"
            h="20px"
            bgPos="center"
            bgSize="contain"
          />
          <Box as="img" src="/beta.png" alt="Beta" w="48px" h="36px" objectFit="contain" flexShrink={0} />
        </Flex>
        <Flex gap="10px">
          <IconButton
            size="sm"
            variant="light"
            aria-label="my events"
            onClick={() => {
              triggerHapticFeedback(ImpactStyle.Medium)
              navigate('/user/events')
            }}
            icon={
              <Icon w="22px" h="22px" viewBox="0 0 20 21">
                <CalendarFilled />
              </Icon>
            }
            borderRadius="full" // Makes the button circular
            _focus={{ boxShadow: 'none' }} // Removes the focus outline
            _active={{ bg: '#c4c4c4' }} // Removes the background on active state
            _hover={{ bg: 'transparent' }} // Removes the background on hover state
            draggable="false" // Prevents the button from being draggable
          />
          <Flex>
            <IconButton
              size="sm"
              variant="light"
              aria-label="notifications"
              onClick={() => {
                triggerHapticFeedback(ImpactStyle.Medium)
                navigate('/user/notifications')
              }}
              icon={
                <Icon w="22px" h="22px">
                  <NotificationFilled />
                </Icon>
              }
              borderRadius="full" // Makes the button circular
              _focus={{ boxShadow: 'none' }} // Removes the focus outline
              _active={{ bg: '#c4c4c4' }} // Removes the background on active state
              _hover={{ bg: 'transparent' }} // Removes the background on hover state
              draggable="false" // Prevents the button from being draggable
            />
            {newNotifications > 0 && (
              <Box
                borderRadius="100px"
                bg="red"
                w="16px"
                h="16px"
                position="absolute"
                top={`${statusBarHeight + 15}px`}
                right="58px"
                color="white"
                fontSize="11px"
                display={newNotifications ? 'flex' : 'none'}
                alignItems="center"
                justifyContent="center"
              >
                {newNotifications}
              </Box>
            )}
          </Flex>

          <Flex>
            <IconButton
              size="sm"
              variant="light"
              aria-label="messages"
              onClick={() => {
                triggerHapticFeedback(ImpactStyle.Medium)
                navigate('/user/messages')
              }}
              icon={
                <Icon w="22px" h="22px">
                  <MessagesFilled />
                </Icon>
              }
              borderRadius="full" // Makes the button circular
              _focus={{ boxShadow: 'none' }} // Removes the focus outline
              _active={{ bg: '#c4c4c4' }} // Removes the background on active state
              _hover={{ bg: 'transparent' }} // Removes the background on hover state
              draggable="false" // Prevents the button from being draggable
            />
            {newMessages > 0 && (
              <Box
                borderRadius="100px"
                bg="red"
                w="16px"
                h="16px"
                position="absolute"
                top={`${statusBarHeight + 15}px`}
                right="15px"
                color="white"
                fontSize="11px"
                display={newMessages ? 'flex' : 'none'}
                alignItems="center"
                justifyContent="center"
              >
                {newMessages}
              </Box>
            )}
          </Flex>
        </Flex>
      </Flex>
      <Divider />
    </Box>
  )
}

export default UserDefaultHeader
